import { render, staticRenderFns } from "./OrderGz.vue?vue&type=template&id=2f30034a&scoped=true&"
import script from "./OrderGz.vue?vue&type=script&lang=js&"
export * from "./OrderGz.vue?vue&type=script&lang=js&"
import style0 from "./OrderGz.vue?vue&type=style&index=0&id=2f30034a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f30034a",
  null
  
)

export default component.exports